"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContext = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var use_context_selector_1 = require("use-context-selector");
var ListContext = (0, use_context_selector_1.createContext)({ dividers: false });
exports.ListContext = ListContext;
var ListContextProvider = function (_a) {
    var children = _a.children, dividers = _a.dividers;
    var value = React.useMemo(function () { return ({ dividers: dividers }); }, [dividers]);
    return (0, jsx_runtime_1.jsx)(ListContext.Provider, tslib_1.__assign({ value: value }, { children: children }));
};
exports.default = ListContextProvider;
